<template>
  <div class="setComponent">
    <!-- 二级标题 -->
    <div class="title">
      <h4>{{$t("wm_lang_html_de8610")}}</h4>
      <h5>{{$t("wm_lang_html_db06c7")}}</h5>
      <el-divider></el-divider>
    </div>
    <!-- 提示栏 -->
    <el-alert
      style="margin:15px 0;"
      :title=$i18n.t('wm_lang_e366cc')+"POP"+this.$i18n.t('wm_lang_674b1e')
      :closable="false"
      type="info">
    </el-alert>
    <!-- 表单 -->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm" size="medium">
      <el-form-item :label="$i18n.t('wm_lang_4c50ee')">
        <el-upload
          class="avatar-uploader"
          action="https://jsonplaceholder.typicode.com/posts/"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_5ac57c')" prop="tex">
        <el-input v-model="ruleForm.tex"></el-input>
        <p class="f12 c_blue">{{$t("wm_lang_html_bf498c")}}</p>
      </el-form-item>
      <el-form-item :label="'select'+$i18n.t('wm_lang_78f395')" prop="select">
        <el-select v-model="ruleForm.select" :placeholder="$i18n.t('wm_lang_708c9d')">
          <el-option :label="$i18n.t('wm_lang_919ca6')" value="1"></el-option>
          <el-option :label="$i18n.t('wm_lang_74225e')" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_4ff1e7')+'/'+$i18n.t('wm_lang_19fcb9')" required>
        <el-col :span="11">
          <el-form-item prop="date1">
            <el-date-picker type="date" :placeholder="$i18n.t('wm_lang_2bebdd')" v-model="ruleForm.date1" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col class="line tc" :span="2">--</el-col>
        <el-col :span="11">
          <el-form-item prop="date2">
            <el-time-picker :placeholder="$i18n.t('wm_lang_2c825a')" v-model="ruleForm.date2" style="width: 100%;"></el-time-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="switch"+this.$i18n.t('wm_lang_a6beb9') prop="switch">
        <el-switch v-model="ruleForm.switch"></el-switch>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_443f46')" prop="type">
        <el-checkbox-group v-model="ruleForm.type">
          <el-checkbox :label="$i18n.t('wm_lang_3c3479')" name="type"></el-checkbox>
          <el-checkbox :label="$i18n.t('wm_lang_b7abee')" name="type"></el-checkbox>
          <el-checkbox :label="$i18n.t('wm_lang_4249f2')" name="type"></el-checkbox>
          <el-checkbox :label="$i18n.t('wm_lang_2cf58f')" name="type"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_9fd1b7')" prop="radio">
        <el-radio-group v-model="ruleForm.radio">
          <el-radio :label="$i18n.t('wm_lang_9fd1b7')+'1'"></el-radio>
          <el-radio :label="$i18n.t('wm_lang_9fd1b7')+'2'"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="'textarea'+$i18n.t('wm_lang_41ec00')" prop="desc">
        <el-input type="textarea" v-model="ruleForm.desc"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">{{$t("wm_lang_html_be5fbb")}}</el-button>
        <el-button @click="resetForm('ruleForm')">{{$t("wm_lang_html_4b9c32")}}</el-button>
      </el-form-item>
    </el-form>
    <!-- 账号检测进度条 -->
    <div class="mt20 mb20">
      <div class="progressBox flexCenter">
      <strong>{{$t("wm_lang_html_e77c07")}}</strong>
      <el-progress :percentage="50" :stroke-width="8" :color="customColors" :format="format" style="width:200px;"></el-progress>
      <el-link type="primary" :underline="false">{{$t("wm_lang_html_f515f8")}}</el-link>
      <p class="ml10">{{$t("wm_lang_html_d4c366")}}...</p>
      </div>
      <p class="f12 c_blue pt10">{{$t("wm_lang_html_df99b1")}}</p>
    </div>
    <!-- 表格 -->
    <el-table
      size="medium"
      :data="tableData"
      style="width: 100%">
       <el-table-column
        type="selection"
        width="45">
      </el-table-column>
      <el-table-column
        :label="$i18n.t('wm_lang_3c18db')"
        width="220">
        <template slot-scope="scope">
          <i class="el-icon-success c_green"></i>
          <i class="el-icon-warning c_orange"></i>
          <i class="el-icon-error c_red"></i>
          <span style="margin-left: 10px">{{ scope.row.detection }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        :label="$i18n.t('wm_lang_1f4c10')">
      </el-table-column>
      <el-table-column
        prop="unread"
        :label="$i18n.t('wm_lang_894a10')">
      </el-table-column>
      <el-table-column
        prop="number"
        :label="$i18n.t('wm_lang_e4b8bb')">
      </el-table-column>
      <el-table-column
        prop="size"
        :label="$i18n.t('wm_lang_58f966')">
      </el-table-column>
       <el-table-column
        fixed="right"
        :label="$i18n.t('wm_lang_2b6bc0')"
        width="160">
        <template>
          <el-link type="danger" :underline="false">{{$t("wm_lang_html_288f0c")}}</el-link>
          <el-link type="primary" :underline="false">{{$t("wm_lang_html_607e7a")}}</el-link>
          <el-link type="primary" :underline="false">{{$t("wm_lang_html_8347a9")}}</el-link>
          <el-link type="success" :underline="false">{{$t("wm_lang_html_a06d40")}}</el-link>
        </template>
      </el-table-column>
    </el-table>

    <br><br>
  </div>
</template>

<script>
export default {
  name: 'setComponent',
  data () {
    return {
      msgindex: this.$i18n.t('wm_lang_dade72'),
      // 进度条
      customColors: [
        {color: '#e6a23c', percentage: 50},
        {color: '#f56c6c', percentage: 80},
        {color: '#67c23a', percentage: 100}
      ],
      // 表格
      tableData: [{
        detection:this.$i18n.t('wm_lang_320dcb'),
        number: '60',
        name: this.$i18n.t('wm_lang_e75969'),
        unread: '5677',
        size: '20.34M'
      }, {
        detection:this.$i18n.t('wm_lang_8dd066'),
        number: '452454',
        name: this.$i18n.t('wm_lang_93d159'),
        unread: '645',
        size: '9.69M'
      }, {
        detection:this.$i18n.t('wm_lang_21cad5'),
        number: '3445',
        name: this.$i18n.t('wm_lang_5cc232'),
        unread: '43',
        size: '0B'
      }, {
        detection:this.$i18n.t('wm_lang_fec2b4'),
        number: '2456',
        name: this.$i18n.t('wm_lang_22b433'),
        unread: '12',
        size: '2.00G'
      }],
      // 表单
      ruleForm: {
        tex: '',
        select: '',
        date1: '',
        date2: '',
        switch: false,
        type: [],
        radio: '',
        desc: ''
      },
      rules: {
        tex: [
          { required: true, message: this.$i18n.t('wm_lang_47631c'), trigger: 'blur' },
          { min: 3, max: 5, message: this.$i18n.t('wm_lang_0c9e6a')+' 3 '+this.$i18n.t('wm_lang_d716f1')+' 5 '+this.$i18n.t('wm_lang_15d410'), trigger: 'blur' }
        ],
        select: [
          { required: true, message: this.$i18n.t('wm_lang_708c9d'), trigger: 'change' }
        ],
        date1: [
          { type: 'date', required: true, message: this.$i18n.t('wm_lang_aa2fb1'), trigger: 'change' }
        ],
        date2: [
          { type: 'date', required: true, message: this.$i18n.t('wm_lang_fbd05a'), trigger: 'change' }
        ],
        type: [
          { type: 'array', required: true, message: this.$i18n.t('wm_lang_0efb20'), trigger: 'change' }
        ],
        radio: [
          { required: true, message: this.$i18n.t('wm_lang_708c9d'), trigger: 'change' }
        ],
        desc: [
          { required: true, message: this.$i18n.t('wm_lang_ad9c40'), trigger: 'blur' }
        ]
      },
      // 上传头像
      imageUrl: ''
    }
  },
  methods: {
    // 账号安全检测进度
    format(percentage) {
      return percentage === 50 ? this.$i18n.t('wm_lang_19ac67') : `${percentage}%`;
    },
    // 表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 上传头像
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error(this.$i18n.t('wm_lang_397654')+' JPG '+this.$i18n.t('wm_lang_e3127c')+'!');
      }
      if (!isLt2M) {
        this.$message.error(this.$i18n.t('wm_lang_80ef9d')+' 2MB!');
      }
      return isJPG && isLt2M;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;}
 .setComponent .title .el-divider--horizontal{margin:10px 0;}
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/setComponent.vue